import React, { useEffect } from "react";
import {Provider, useDispatch, useSelector} from "react-redux";
import GlobalStyles from './styles/globalStyle';
import { store, persistor } from '@stores';
import Routes from './router';
import AppProvider from './AppProvider';
import {getCredentials, refreshUser} from '@stores/reducers/auth.reducer';
import {
  fetchCompanies,
  fetchUserCompanies,
  setSelectedCompany,
} from '@stores/reducers/company.reducer';
import { GlobalAlertProvider } from "@contexts/GlobalAlertContext";
import { PersistGate } from 'redux-persist/integration/react';

const AppContent = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);
  const token = useSelector(state => state.auth.auth.access_token);
  const user = useSelector(state => state.auth.user);
  const companiesUser = useSelector(state => state.company.companiesUser);
  const selectedCompany = useSelector(state => state.company.selectedCompany);

  useEffect(() => {
    dispatch(getCredentials());
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn && token) {
      dispatch(refreshUser());
      dispatch(fetchCompanies());
      dispatch(fetchUserCompanies());
    }
  }, [dispatch, isLoggedIn, token]);

  useEffect(() => {
    if (!isLoggedIn || selectedCompany) {
      return;
    }

    if (companiesUser.length === 1) {
      dispatch(setSelectedCompany(companiesUser[0]));
    }
  }, [dispatch, isLoggedIn, companiesUser, selectedCompany]);

  return (
    <>
      <GlobalStyles />
      <GlobalAlertProvider>
        <Routes />
      </GlobalAlertProvider>
    </>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="notranslate">
          <AppProvider>
            <AppContent />
          </AppProvider>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
